import { settingsPagePath } from "@/components/sidebar/useActiveApp";

function usageTabPath(
  org: string | null | undefined,
  tab: "codesmith" | "github-actions",
): string {
  const path = org ? `/${org}/usage` : "/usage";
  return `${path}?tab=${tab}`;
}

export function codesmithUsagePath(org: string | null | undefined): string {
  return usageTabPath(org, "codesmith");
}

export function githubActionsUsagePath(org: string | null | undefined): string {
  return usageTabPath(org, "github-actions");
}

/**
 * Resolves a global keydown to a settings navigation path, or null when the
 * event is not the settings shortcut (Command+, on macOS, Ctrl+, elsewhere).
 */
export function settingsShortcutPath(
  event: Pick<KeyboardEvent, "key" | "metaKey" | "ctrlKey">,
  org: string | null | undefined,
  isCodesmithPage: boolean,
): string | null {
  if (event.key !== "," || !(event.metaKey || event.ctrlKey)) return null;
  return settingsPagePath(org, isCodesmithPage);
}
